<template>
  <v-div class="EventSponsors" :pa-3="displayIsMobile || displayIsTablet">
    <v-div v-if="title" pb-2 text-primary border-bottom-secondary-thick>
      <h2>{{ title }}</h2>
    </v-div>
    <ContainerGrid>
      <LayoutItems
        :items="sponsors"
        component-name="EventSponsorSummary"
        cols="12"
        sm="6"
        md="6"
        lg="4"
      />
    </ContainerGrid>
  </v-div>
</template>

<script>
import ContainerGrid from "~/components/layout/ContainerGrid";
import LayoutItems from "~/components/layout/LayoutItems";

import {
  displayIsMobile,
  displayIsTablet,
  displayIsDesktop,
} from "~/components/utilities/displayBreakpoints";

export default {
  name: "EventSponsors",
  components: {
    ContainerGrid,
    LayoutItems,
  },
  props: {
    title: { type: String, default: undefined },
    sponsors: { type: Array, default: () => [] },
  },
  computed: {
    displayIsMobile,
    displayIsTablet,
    displayIsDesktop,
  },
};
</script>

<style>
.EventSponsors h2 {
  font-size: 16px;
  font-weight: normal;
}
</style>
